import styled, { css } from 'styled-components'

import { StatelessDropdown, truncateStyles, Dropdown } from '@sketch/components'
import { ReactComponent as ArrowRight } from '@sketch/icons/chevron-right-17'

export const DropdownWrapper = styled(StatelessDropdown)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: absolute;
`

export const ContextMenuNav = styled.nav`
  /* max height = 100% viewport height - header height - extra margin */
  max-height: ${({ theme }) =>
    `calc(100vh - ${theme.header.height}px - 70px);`};
  overflow: auto;
  background: ${({ theme }) => theme.colors.background.secondary.A};

  ol {
    margin-top: 0;
    margin-bottom: 0;
    list-style-type: none;
    padding: 0;
  }
`

interface ContextMenuItemProps {
  $level: number
  $isSymbol?: boolean
}

export const SelectLayerMenuItem = styled(Dropdown.Item)<ContextMenuItemProps>(
  ({ theme, $level, $isSymbol }) => css`
    display: flex;
    gap: 8px;
    align-items: center;

    height: 32px;

    padding-left: ${theme.space[3] + $level * theme.space[3]}px;

    /* &&& is needed to increase specificity and avoid showing the hover state
    for a selected item */
    &&&[aria-selected='true'] {
      background-color: ${$isSymbol
        ? theme.colors.inspect.component.A
        : theme.colors.sketch.A};
      color: ${theme._name === 'dark'
        ? theme.colors.foreground.secondary.A
        : theme.colors.foreground.primary.A};

      [data-exportable-icon] {
        /* This background can't be with alpha because the purpose is to
        generate a border around the knife icon and hide the icon that is
        behind, so in this case #f8eee5 is emulating the background of a
        selected element (theme.colors.background.tertiary.C) */
        background: #f8eee5;
      }
    }
  `
)

export const SelectListLayerName = styled.p<{ $isSymbol?: boolean }>`
  margin: 0;
  font-size: 0.875rem;
  width: 100%;
  ${truncateStyles};
  color: ${({ theme, $isSymbol }) =>
    $isSymbol ? theme.colors.inspect.component.A : 'inherit'};

  [aria-selected='true'] & {
    /* When a symbol is selected we don't change the text color */
    color: inherit;
  }
`

export const SelectLayerItem = styled(Dropdown.Item)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const SelectLayerItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ArrowIcon = styled(ArrowRight)`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const MenuIcon = styled.div`
  width: 17px;
  height: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledDropdownItem = styled(Dropdown.Item)`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 30px;
`

export const StyledDropdownHeader = styled(Dropdown.Header)`
  display: flex;
  gap: 8px;
  align-items: center;
  /* Override default margin to align with items */
  margin-left: 0;
  padding-left: 20px;
  padding-right: 20px;
`

export const DropdownHeaderText = styled.span`
  ${truncateStyles};
`
